import { LessonLink } from "@jelly/lesson";
import { findChapterForLinkByCourseLesson } from "../../../../services/Utils";

import course02 from "../../../course/course-02/course";
import lesson0215 from "../lesson-15/lesson";

const lessonLinks: LessonLink[] = [
  {
    id: "bd7aafd7-a59b-468a-a9eb-89898d8e43c3",
    course: {
      id: course02.id,
      slug: course02.slug as string,
      name: course02.name,
      publicId: course02.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course02, lesson0215),
    lesson: lesson0215,
  },
];

export default lessonLinks;
